import { render, staticRenderFns } from "./RequestAccountStatementForm.vue?vue&type=template&id=2e72b5c0&scoped=true&"
import script from "./RequestAccountStatementForm.vue?vue&type=script&lang=js&"
export * from "./RequestAccountStatementForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e72b5c0",
  null
  
)

export default component.exports